module.exports = __webpack_public_path__ + "static/media/web-development2.4b489142.jpg";